import { Group, Text } from "@mantine/core"
import { RingProgress } from "@tfg/ui"

import { ActivityProgressIcon } from "~/pages/SupplierPortal/TraceabilityRequests/components/ActivityProgressIcon"
import { useTraceabilityOperations } from "~/pages/SupplierPortal/TraceabilityRequests/context/useTraceabilityOperations"
import { useInformationRequestContext } from "~/pages/SupplierPortal/TraceabilityRequests/store/InformationRequestContext"
import { useGetOperations } from "~/utils/operations"

export const ActivityTitle = () => {
  const { operationItem, isTransferred } = useTraceabilityOperations()
  const { progressByOperationId } = useInformationRequestContext()
  const activityName = operationItem.activityName
  const operation = useGetOperations()[activityName]
  if (!operation) return null

  return (
    <Group wrap="nowrap" align="center">
      <RingProgress
        size={40}
        roundCaps
        styles={{
          label: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        }}
        thickness={4}
        sections={[
          {
            value: progressByOperationId[operationItem.operation?.id ?? 0],
          },
        ]}
        label={
          <ActivityProgressIcon
            progress={progressByOperationId[operationItem.operation?.id ?? 0]}
            activityName={activityName}
            size={20}
            isTransferred={isTransferred}
          />
        }
      />
      <Text fw={700} size="sm">
        {operation.name}
      </Text>
    </Group>
  )
}
